import React from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";

const COIN_BASE = 3;
const COIN_NEXT = 5;

// Shows today's coin run so learners are nudged to finish another lesson today.
// Used both at the top of the course player and inside the quiz coin celebration.
export default function CoinStreakBanner({ celebrationsEnabled = true, className = "", compact = false }) {
  const { user } = useAuth();
  const { t } = useI18n();
  if (!user || !celebrationsEnabled) return null;
  // Backend already resets the count at the start of each calendar day.
  const doneToday = user.coins_today_count || 0;
  const nextCoins = doneToday === 0 ? COIN_BASE : COIN_NEXT;

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
      className={`rounded-2xl px-5 ${compact ? "py-2" : "py-3"} flex items-center gap-3 flex-wrap ${className}`}
      style={{ background: "linear-gradient(135deg,#FFF6D6,#FFE29A)", border: "1px solid rgba(255,158,0,0.45)" }}
      data-testid="coin-streak-banner"
    >
      {!compact && (
        <motion.span
          className="text-2xl"
          animate={{ rotate: [0, -12, 12, 0] }}
          transition={{ duration: 1.6, repeat: Infinity, repeatDelay: 1.2 }}
        >🪙</motion.span>
      )}
      {doneToday === 0 ? (
        <div className="text-sm sm:text-base font-semibold text-[#5c4600]" data-testid="coin-banner-text">
          {t("Finish a lesson today to start your coin run — your first lesson is worth")}
          <span className="font-extrabold text-[#8a5a00]"> {nextCoins.toLocaleString()} {t("coins!")}</span>
        </div>
      ) : (
        <div className="text-sm sm:text-base font-semibold text-[#5c4600]" data-testid="coin-banner-text">
          <span className="font-extrabold text-[#8a5a00]">🔥 {doneToday} {t(doneToday > 1 ? "lessons done today." : "lesson done today.")}</span>
          {" "}{t("Your next lesson is worth")}
          <span className="font-extrabold text-[#8a5a00]"> {nextCoins.toLocaleString()} {t("bonus coins")}</span> {t("— every extra lesson today pays 5!")}
        </div>
      )}
    </motion.div>
  );
}
